<template>
  <div class="banner-section" >
    <img :src="bannerImage" class="banner-image" @click="goToChat()" /> 
  </div>
</template>
  
  <script>
export default {
  name: 'SAchatCommingSoonBanner',
  data() {
    return {
      bannerImage: require('@/assets/images/ChatBannerinExpertBuzzandExpertView.svg'),
    };
  },
  methods: {
    goToChat() {
      const profession = this.userProfile && this.userProfile.profession;
      if (profession === 'Retail Investor') {
        this.$router.push('/expert-list');
      } else {
        this.$router.push('/chat');
      }
    },
  },
  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.banner-section {
  margin: 0px;
  text-align: center;

  .banner-image {
    width: 100%;
    margin: 10px 0px 20px 0px;
    border-radius: 8px;
    object-fit: cover;
    cursor: pointer;
  }
}

/* Responsive Styles */
@media screen and (max-width: 1060px) {
  // Tablets
  .banner-section {
    .banner-image {
      margin: 10px 0px 110px 0px;
    }
  }
}
</style>